export const FORM_CODE_FF002 = 'FF002';

export type EmploymentContractStepId = 'preview' | 'agree' | 'signedPreview';

export type EmploymentContractFormValues = {
  documentRead?: 'yes' | 'no';
  agree?: 'true' | 'false';
  consentDate?: string;
};

export type EmploymentContractCommit = {
  stepId: EmploymentContractStepId;
  label: string;
  displayValue: string;
};
